// 音频标注
import {
  audioMark1,
  audioMark2,
  audioMark3,
  audioMark4,
  audioMark5,
  audioMark6,
  audioMark7,
  audioMark8,
  audioMark9,
  audioMark10,
  audioMark11,
  audioMark12,
  audioMark13,
} from '@/utils/images.js'

const primaryGuide = [
  {
    rightnavs: '音频标注',
    title: '第一步：创建数据集',
    content: '',
    note: '',
    level: 1,
    id:'guide-1',
    children: [
      {
        id:'guide-1-1',
        level: 2,
        content:
          '1、选择模型类型：点击模型类型下拉列表，选择“音频标注”类型，进入音频标注模型页面。',
        note: '',
        imgUrlList: [
          {
            url: audioMark1,
            label: '',
          },
        ],
      },
      {
        id:'guide-1-2',
        level: 2,
        content:
          '2、创建数据集：点击“创建数据集”按钮，进入数据集创建界面，输入数据集名称、描述，完成数据集创建。',
        note: '',
        imgUrlList: [
          {
            url: audioMark2,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    id:'guide-2',
    level: 1,
    title: '第二步：标注音频',
    content: '',
    note: '',
    children: [
      {
        id:'guide-2-1',
        level: 2,
        content:
          '1、进入“音频标注”页面，选择数据集；点击“上传音频”，按照上传说明从本地将音频上传。',
        note: '',
        imgUrlList: [
          {
            url: audioMark3,
            label: '',
            display: '',
          },
        ],
      },
      {
        id:'guide-2-2',
        level: 2,
        note: '',
        content: '2、添加标签：点击 + 符号按钮，添加标签。',
        imgUrlList: [
          {
            url: audioMark4,
            label: '',
            display: '',
          },
        ],
      },
      {
        id:'guide-2-3',
        level: 2,
        content:
          '3、标注音频：在标签栏选中某一标签，在音频区拖动音频片段截取图标（也可直接输入音频片段起止时间）选取音频片段，点击“添加到列表”，再点击“保存”，完成音频标注。',
        imgUrlList: [
          {
            url: audioMark5,
            label: '',
            display: '',
          },
        ],
        note: [
          '①每一次截取添加音频后都要点击“保存”按钮，音频片段标注信息才会被记录。',
          '②同一个音频文件需要标注多个标签时，可切换标签后进行标注。',
          '③每个标签下的音频标注数需要不少于40个，才能满足后续的模型训练。',
        ],
      },
    ],
  },
  {
    id:'guide-3',
    level: 1,
    title: '第三步：创建模型',
    content: '',
    note: '',
    children: [
      {
        id:'guide-3-1',
        level: 2,
        content:
          '1、点击“创建模型”按钮，进入创建模型页面，输入模型名称、模型描述，点击“确定”，完成模型创建。',
        note: '',
        imgUrlList: [
          {
            url: audioMark6,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    id:'guide-4',
    level: 1,
    title: '第四步：训练模型',
    content: '',
    note: '',
    children: [
      {
        id:'guide-4-1',
        level: 2,
        content:
          '1、点击“训练模型”按钮，进入训练模型界面，选择训练的模型以及模型数据，勾选需要训练的模型标签后，开始训练。',
        note: '',
        imgUrlList: [
          {
            url: audioMark7,
            label: '',
            display: '',
          },
        ],
      },
      {
        id:'guide-4-2',
        level: 2,
        content:
          '2、查看模型训练进度：点击“我的模型”，进入我的模型页面，选择模型-版本数，进入该模型的版本详情页面。',
        note: '',
        imgUrlList: [
          {
            url: audioMark8,
            label: '',
            display: '',
          }
        ],
      },
      {
        id:'guide-4-3',
        level: 2,
        content: '当模型完成训练后，版本模型状态为“训练完成”。',
        note: [
          '①评估报告：显示该版本模型的总体性能，作为评估模型的一个参考指标。',
          '②下载模型：模型状态为”训练完成后“可点击”下载模型“，将模型下载至本地。',
        ],
        imgUrlList: [
          {
            url: audioMark9,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    id:'guide-5',
    level: 1,
    title: '第五步：校验模型',
    content: '',
    note: '',
    children: [
      {
        id:'guide-5-1',
        level: 2,
        content:
          '1、点击“校验模型”按钮，进入模型校验页面，选择校验的模型、模型版本；点击“上传音频”，完成校验音频上传；点击“开始校验”，进行模型校验。',
        note: '',
        imgUrlList: [
          {
            url: audioMark10,
            label: '',
            display: '',
          },
        ],
      },
      {
        id:'guide-5-2',
        level: 2,
        content: '2、输出校验结果：',
        note: '',
        imgUrlList: [
          {
            url: audioMark11,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    id:'guide-6',
    level: 1,
    title: '第六步：发布模型',
    content: '',
    note: '',
    children: [
      {
        id:'guide-6-1',
        level: 2,
        content:
          '1、点击左侧“发布模型”按钮，选择发布的模型、版本号；点击“发布模型”，完成模型发布。',
        note: '',
        imgUrlList: [
          {
            url: audioMark12,
            label: '',
            display: '',
          },
        ],
      },
      {
        id:'guide-6-2',
        level: 2,
        content: '2、在“我的模型”，查看模型状态更改为“已发布”。',
        note: '',
        imgUrlList: [
          {
            url: audioMark13,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    level: 1,
    footer: '关于模型训练模块的更多功能操作，可查看完整版用户手册了解哦～',
  },
]

//附件
const secodeGuide = []

export default {
  primaryGuide,
  secodeGuide,
}
